import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { BsSend } from "react-icons/bs";
import { socket } from "../../socket";
import { getChatMessages } from "../../Services/UserService";

const Chat = () => {
    const location = useLocation();
    const params = useParams();
    const user_id = params?.id;
    const full_name = location.state?.full_name;
    const user_role = location.state?.role;

    const chatBodyRef = useRef(null);
    const [adminId, setAdminId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    useEffect(() => {
        if (!socket.connected) {
            socket.connect();
        }
    
        const admin = JSON.parse(localStorage.getItem("user"));

        if (admin && admin._id) {
            setAdminId(admin._id);
            socket.emit("user-connected", { userId: admin._id });
        }
    
        const handleReceiveMessage = (data) => {
            console.log("Message received =====", data);
            const currentDateTime = new Date().toISOString();
    
            setMessages((prevMessages) => [
                ...prevMessages,
                {
                    sender_id: data.senderId,
                    message: data.message,
                    createdAt: currentDateTime,
                },
            ]);
        };
    
        // Listen for incoming messages
        socket.on("receive-message", handleReceiveMessage);
    
        // Cleanup function to prevent multiple listeners
        return () => {
            socket.off("receive-message", handleReceiveMessage);
        };
    }, []);

    const sendMessage = () => {
        if (newMessage.trim() === "") return;

        const currentDateTime = new Date().toISOString();
        console.log("userId ====", userId)

        socket.emit("send-message", {
            senderId: adminId,
            receiverId: userId,
            message: newMessage.trim(),
            role: user_role === "User" ? "Driver": "User",
        });

        setMessages((prevMessages) => [
            ...prevMessages,
            {
                sender_id: adminId,
                message: newMessage.trim(),
                createdAt: currentDateTime
            },
        ]);

        setNewMessage("");
    };

    const fetchChatMessages = async () => {
        const admin = JSON.parse(localStorage.getItem("user"));

        const res = await getChatMessages(params?.id);
        setMessages(res?.data);
    };

    useEffect(() => {
        setUserId(params?.id);
        fetchChatMessages();
    }, []);

    useEffect(() => {
        // Scroll to the bottom when messages change
        if (chatBodyRef.current) {
          chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
    }, [messages]);

    function formatDateTime(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const period = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const formattedHours = String(hours).padStart(2, '0');
    
        return `${day}/${month}/${year}  ${formattedHours}:${minutes} ${period}`;
    }

    return (
        <Container fluid className="d-flex flex-column border rounded" style={{ height: "92vh", maxWidth: "96vw" }}>
            {/* Fixed Header */}
            <Row className="bg-secondary text-white p-2 text-center" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                <h5 className="m-0">Chat with {full_name}</h5>
            </Row>

            {/* Scrollable Chat Area */}
            <Row ref={chatBodyRef} className="flex-grow-1 overflow-auto p-3" style={{ flex: 1, backgroundColor: "#f1f1f1" }}>
                <Col>
                    {messages.map((msg) => (
                        <Card
                            key={msg?._id}
                            className={`mb-3 p-2 ${msg?.sender_id === adminId ? "ms-auto text-end text-black" : "me-auto bg-primary text-white"}`}
                            style={{ maxWidth: "60%", padding: "8px", fontSize: "14px" }}
                        >
                            <Card.Body className="p-2">
                                <p className="mb-0">{msg?.message}</p>
                                <p className="text-muted small mb-0 mt-1">{formatDateTime(msg?.createdAt)}</p>
                            </Card.Body>
                        </Card>
                    ))}
                </Col>
            </Row>

            {/* Fixed Footer */}
            <Row className="p-2 bg-light" style={{ position: "sticky", bottom: 0, zIndex: 1 }}>
                <Col xs={10}>
                    <Form.Control
                        type="text"
                        placeholder="Type a message..."
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        style={{ fontSize: "14px", padding: "6px" }}
                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                    />
                </Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">
                    <Button variant="primary" className="d-flex align-items-center justify-content-center" onClick={sendMessage} style={{ width: "100%" }}>
                        <BsSend size={18} />
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default Chat;
